Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    spacing = _STYLES$useStyles.spacing;
  var _barHeightRem = 1.625;
  var container = {
    maxWidth: _styles.STYLES.grid.maxBoxWidth,
    width: '100%'
  };
  var item = {
    flexDirection: 'row',
    alignItems: 'flex-end'
  };
  var itemLabel = {
    borderRightColor: COLORS.silver,
    borderRightWidth: (0, _styles.getREM)(0.0625),
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: (0, _styles.getREM)(_barHeightRem),
    paddingRight: (0, _styles.getREM)(0.5),
    marginRight: (0, _styles.getREM)(0.5),
    minWidth: (0, _styles.getREM)(4.5),
    width: '25%'
  };
  var itemLabel_gap = {
    paddingTop: (0, _styles.getREM)(0.875)
  };
  var itemBarContainer = {
    flex: 1,
    marginRight: (0, _styles.getREM)(0.5)
  };
  if (bp.mobile_xs) {
    itemBarContainer.display = 'none';
  }
  var itemBar = {
    borderRadius: (0, _styles.getREM)(0.375),
    height: (0, _styles.getREM)(_barHeightRem)
  };
  var itemValue = {
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: (0, _styles.getREM)(_barHeightRem),
    marginLeft: 'auto',
    minWidth: (0, _styles.getREM)(4),
    width: '17%',
    textAlign: 'right',
    paddingLeft: (0, _styles.getREM)(0.5)
  };
  if (bp.is([bp.mobile_l, bp.mobile_xl, bp.tablet, bp.desktop])) {
    itemValue.fontSize = _styles.STYLES.fontSize.s;
  }
  var treeContainer = Object.assign({}, itemBarContainer, {
    flexDirection: 'row',
    alignItems: 'center'
  });
  var treeContainerText = Object.assign({
    color: COLORS.goblin
  }, fontSemiBold, {
    marginLeft: spacing.xs,
    textAlign: 'left',
    fontSize: _styles.STYLES.fontSize.xs
  });
  if (bp.is([bp.mobile_l, bp.mobile_xl, bp.tablet, bp.desktop])) {
    itemLabel.fontSize = _styles.STYLES.fontSize.s;
    treeContainerText.fontSize = _styles.STYLES.fontSize.s;
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    item: item,
    itemLabel: itemLabel,
    itemLabel_gap: itemLabel_gap,
    itemBarContainer: itemBarContainer,
    itemBar: itemBar,
    itemValue: itemValue,
    treeContainer: treeContainer,
    treeContainerText: treeContainerText
  });
  return {
    styles: styles
  };
};